import { Checkbox, Divider } from "@material-ui/core";
import BN from "bn.js";
import { useState } from "react";
import styled from "styled-components";
import { Flex } from "../../../../components/layout";

export const denominator = new BN(10).pow(new BN(18));

export const useAcceptedStakingTerms = () => {
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
  const [moreTermsAccepted, setMoreTermsAccepted] = useState<boolean>(false);

  const component = (
    <>
      <Flex>
        <Checkbox
          checked={termsAccepted}
          onChange={(e) => setTermsAccepted(e.target.checked)}
          id="terms-accepted"
        />
        <label htmlFor="terms-accepted">
          I have read the&nbsp;
          <a
            href="https://sekuritance.com/footer/terms-and-conditions/"
            target="_blank"
            rel="noreferrer"
          >
            terms and conditions
          </a>
          &nbsp;and agree to them.
        </label>
      </Flex>
      <Flex>
        <Checkbox
          checked={moreTermsAccepted}
          onChange={(e) => setMoreTermsAccepted(e.target.checked)}
          id="more-terms-accepted"
        />
        <label htmlFor="more-terms-accepted">
          I have read the Staking Contract Information, regarding the lock
          period and understand the Annual Reward Percentage indicated on this
          page
        </label>
      </Flex>
    </>
  );

  return {
    component,
    termsAccepted: termsAccepted && moreTermsAccepted,
  };
};

export const StyledDivider = styled(Divider)`
  margin: 2em 0;
`;
